import { useDataProvider, useNotify, useRefresh } from "react-admin";
import { IconButton, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

export const SortStepperField = ({ record, step = 1, min = 0 }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    if (!record) return null;

    const value = Number.isFinite(record.sort) ? record.sort : 0;

    const updateSort = async (next) => {
        const nextValue = Math.max(min, next);

        try {
            await dataProvider.update("wiki", {
                id: record.id,
                data: { sort: nextValue },
                previousData: record,
            });
            refresh();
        } catch (e) {
            notify("Sort konnte nicht gespeichert werden.", "warning");
        }
    };

    const stop = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <div style={{ display: "flex", alignItems: "center" }} onClick={stop}>
            <IconButton
                size="small"
                onClick={(e) => {
                    stop(e);
                    updateSort(value - step);
                }}
                aria-label="sort -"
            >
                <RemoveIcon fontSize="small" />
            </IconButton>

            <Typography variant="body2" style={{ width: 32, textAlign: "center" }}>
                {value}
            </Typography>

            <IconButton
                size="small"
                onClick={(e) => {
                    stop(e);
                    updateSort(value + step);
                }}
                aria-label="sort +"
            >
                <AddIcon fontSize="small" />
            </IconButton>
        </div>
    );
};
